import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import Portfolio from '../../components/Portfolio'
import { projects } from '../../data/morteros-tecnicos.js'

const MorterosTecnicos = () => (
    <div>
        <Helmet>
            <title>Soluciones Tecnicas: Morteros técnicos</title>
        </Helmet>

        <Portfolio title="Morteros técnicos" projects={projects} />
    </div>
)

export default MorterosTecnicos



// WEBPACK FOOTER //
// ./src/pages/soluciones-tecnicas/morteros-tecnicos.js